import type { DragEvent, ReactNode } from "react";

type UploadDropBoundaryProps = {
  children: ReactNode;
};

function isFileDrag(event: DragEvent<HTMLDivElement>) {
  return Array.from(event.dataTransfer.types).includes("Files");
}

export function UploadDropBoundary({ children }: UploadDropBoundaryProps) {
  return (
    <div
      onDragOver={(event) => {
        if (!isFileDrag(event)) {
          return;
        }

        event.dataTransfer.dropEffect = event.defaultPrevented ? "copy" : "none";
      }}
      onDrop={(event) => {
        if (!isFileDrag(event) || event.defaultPrevented) {
          return;
        }

        event.dataTransfer.dropEffect = "none";
        event.preventDefault();
        event.stopPropagation();
      }}
    >
      {children}
    </div>
  );
}
